import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap,
  MemoizedSelector
} from '@ngrx/store';

import * as fromUser from './users.reducer';
import { Store, select } from '@ngrx/store';
import { map, filter } from 'rxjs/operators';
import { User } from '../../../models/user.model';



// export const selectUserState = createFeatureSelector<fromUser.State>('userReducer');
export const selectUserState = createFeatureSelector<fromUser.State>('userReducer');
export const selectAddUserCompleted = createSelector(selectUserState,
  fromUser.getUserStatus
);

export const { selectAll: selectAllUsers } = fromUser.userAdapter.getSelectors(
  selectUserState
);


export const {
  selectIds: userIds,
  selectEntities: userEntities,
  selectAll: allUsers,
  selectTotal: totalUsers
} = fromUser.userAdapter.getSelectors(selectUserState);


export const selectUsersById = createSelector(
  allUsers,
  (user: User[], { id }: { id: string }) => user.filter(theUser => theUser.id === id)
);

export const selectUsersByCompanyId = createSelector(
  allUsers,
  (user: User[], { companyId }: { companyId: string }) => user.filter(theUser => theUser.companyId === companyId)
);



